<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">マーク登録</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div>
          <h1>マーク情報入力</h1>
          <div class="column-list">
            <div class="list-input-title">マークコード</div>
            <div class="list-input-content">
              <app-mark-code-text-input id="txt_MarkCode" #txt_MarkCode [subid]="'txt_MarkCode'" [maxChars]="3"
                [restrict]="'[0-9]'" [tabindex]="0" [disabled]="!kymw1503Model.markCodeEnabled" [editable]="true"
                [(ngModel)]="kymw1503Model.markCode" style="width: max-content;" [required]="true">
              </app-mark-code-text-input>
              <app-checkbox-label id="chk_DesignateCode" #chk_DesignateCode [subid]="'chk_DesignateCode'" label="コード指定"
                [tabindex]="0" [disabled]="kymw1503Model.designateCodeDisabled"
                [(ngModel)]="kymw1503Model.designateCode" (change)="eventDesignateCode_CLICKHandler()"
                style="display:flex; align-items:center;">
              </app-checkbox-label>
            </div>

            <div class="list-input-title">マーク名</div>
            <div class="list-input-content">
              <app-not-null-text-input id="txt_MarkName" #txt_MarkName [subid]="'txt_MarkName'"
                [restrict]="'[ -￮]'" [maxChars]="25" [displayCountField]="false" [fullOnly]="true"
                [editable]="true" [useDisabledBgColor]="" [(ngModel)]="kymw1503Model.markName"
                [disabled]="kymw1503Model.markNameDisabled" [tabindex]="0" [style.width.px]="380">
              </app-not-null-text-input>
            </div>

            <div class="list-input-title">グループ</div>
            <div class="list-input-content">
              <select class="combo-box-required" id="cmb_MarkGroup" #cmb_MarkGroup [tabindex]="0"
                [(ngModel)]="kymw1503Model.selectedMarkGroup" [style.width.px]="200">
                <ng-template ngFor let-item [ngForOf]="kymw1503Model.markGroupList">
                  <option value="{{item.MarkGroupCode}}">{{item.Caption}}</option>
                </ng-template>
              </select>
            </div>

            <div class="list-input-title">マーク区分</div>
            <div class="list-input-content">
              <select class="combo-box-required" id="cmb_SupplyPromoteMarkDiv" #cmb_SupplyPromoteMarkDiv [tabindex]="0"
                [(ngModel)]="kymw1503Model.selectedSupplyPromoteMarkDiv" [style.width.px]="200">
                <ng-template ngFor let-item [ngForOf]="kymw1503Model.supplyPromoteMarkDivList">
                  <option value="{{item.CodeValue}}">{{item.CodeName}}</option>
                </ng-template>
              </select>
            </div>
          </div>
        </div>
        
        <div>
          <h2>使用開始</h2>
          <div class="column-list">
            <div class="list-input-title">受注コード</div>
            <div class="list-input-content">
              <app-order-code-text-input id="txt_StartOrderCode" #txt_StartOrderCode [subid]="'txt_StartOrderCode'"
                [catalogIDField]="lbl_StartDelivCatalogId" [tabindex]="0" [initFocusItem]="txt_StartOrderCode"
                [disabled]="!kymw1503Model.startOrderCodeEnabled" [required]="true"
                [(ngModel)]="kymw1503Model.startOrderCode" style="width: max-content;" >
              </app-order-code-text-input>
              <app-checkbox-label id="chk_NotDesignateStart" #chk_NotDesignateStart [subid]="'chk_NotDesignateStart'"
                label="指定無し" [tabindex]="0" [disabled]="kymw1503Model.notDesignateStartDisabled"
                [(ngModel)]="kymw1503Model.notDesignateStart" (change)="eventNotDesignateStart_CLICKHandler()"
                style="display:flex; align-items:center;">
              </app-checkbox-label>
            </div>

            <div class="list-input-title">配達企画回(翌週)</div>
            <div class="list-input-content">
              <input type="text" id="lbl_StartDelivCatalogId" #lbl_StartDelivCatalogId
                [disabled]="kymw1503Model.startDelivCatalogIdDisabled" class="deliv-catalog" readonly/>
            </div>
          </div>
        </div>

        <div>
          <h2>使用終了</h2>
          <div class="column-list">
            <div class="list-input-title">受注コード</div>
            <div class="list-input-content">
              <app-order-code-text-input id="txt_EndOrderCode" #txt_EndOrderCode [subid]="'txt_EndOrderCode'"
                [catalogIDField]="lbl_EndDelivCatalogId" [tabindex]="0" [initFocusItem]="txt_EndOrderCode"
                [disabled]="!kymw1503Model.endOrderCodeEnabled"  [required]="true"
                [(ngModel)]="kymw1503Model.endOrderCode" style="width: max-content;">
              </app-order-code-text-input>
              <app-checkbox-label id="chk_NotDesignateEnd" #chk_NotDesignateEnd [subid]="'chk_NotDesignateEnd'"
                label="指定無し" [tabindex]="0" [disabled]="kymw1503Model.notDesignateEndDisabled"
                [(ngModel)]="kymw1503Model.notDesignateEnd" (change)="eventNotDesignateEnd_CLICKHandler()"
                style="display:flex; align-items:center;">
              </app-checkbox-label>
            </div>

            <div class="list-input-title">配達企画回(翌週)</div>
            <div class="list-input-content">
              <input type="text" id="lbl_EndDelivCatalogId" #lbl_EndDelivCatalogId
                [disabled]="kymw1503Model.endDelivCatalogIdDisabled" class="deliv-catalog" readonly/>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" id="btn_AddMark"
            (click)="eventAddMark_CLICKHandler()" [tabindex]="0">追加</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>